import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { AppServiceService } from 'src/app/app-service.service';
import { environment } from 'src/environments/environment';
import { UserDetailsMainModel } from 'src/app/user-details-model';





@Injectable({
  providedIn: 'root'
})

export class AuthGuard extends KeycloakAuthGuard {
  userDetails: UserDetailsMainModel;
  constructor(
    public override router: Router,
    public keycloak: KeycloakService, public appService: AppServiceService
  ) {
    super(router, keycloak);
  }
  async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return new Promise(async (resolve) => {
      let permission;
      if (!this.authenticated) {
        await this.keycloak.login({
          redirectUri: window.location.origin + "/" + environment.AppName + "/" + state.url,
        });
        return resolve(this.authenticated);
      }

      this.appService.userDetails.subscribe(d => this.userDetails = d);
      // Allowed Roles, LEvel 
      const requiredRoles: string[] = route.data.roles;
      let getAccessLevel: number[] = route.data.accessLevel;

      if (this.userDetails) {
        //Logged in user role,level
        let secssionArr: number = this.userDetails.roles[0].accessLevel;
        let accessPermission = getAccessLevel.some(e => e == secssionArr);

        if (!requiredRoles || requiredRoles.length === 0) {
          permission = true;
        } else {
          if (!this.roles || this.roles.length === 0) {
            permission = false
          }
          for (const role of this.roles) {
            for (const allowedRole of requiredRoles) {
              if (role.toLowerCase() === allowedRole.toLowerCase() && accessPermission) {
                permission = true;
                break;
              }
            }
          }
        }
        if (!permission) {
          this.router.navigate(['../../access-denied'])
        }
        resolve(permission)  
      }
      else{
        resolve(permission = true)
      }
    });
  }
}